/**
 * Default: Config
 *
 * @copyright 2026 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

// -------
// Private
// -------

// Icons
const icons = {
	above : '<span aria-hidden="true" class="fa-regular fa-arrow-up"></span>',
	below : '<span aria-hidden="true" class="fa-regular fa-arrow-down"></span>',
	clock : '<span aria-hidden="true" class="fa-regular fa-clock"></span>',
	close : '<span aria-hidden="true" class="fa-regular fa-times"></span>',
	next  : '<span aria-hidden="true" class="fa-regular fa-chevron-right"></span>',
	prev  : '<span aria-hidden="true" class="fa-regular fa-chevron-left"></span>',
	remove: '<span aria-hidden="true" class="fa-regular fa-trash-can"></span>'
};

// ------
// Public
// ------

// Export
export default {
	icons
};
